// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.content {
  margin: 20px;
  background-color: white;
}

.error-text {
  font-size: 12px;
}

.button-container {
  margin: 24px 0 12px 0;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/error-handler/not-authorized/not-authorized.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AACJ;;AAEA;EACI,YAAA;EACA,uBAAA;AACJ;;AAEA;EAEI,eAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,aAAA;EACA,uBAAA;AAAJ","sourcesContent":[".center-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.content {\n    margin: 20px;\n    background-color: white;\n}\n\n.error-text {\n    // color: darkred;\n    font-size: 12px;\n}\n\n.button-container {\n    margin: 24px 0 12px 0;\n    display: flex;\n    justify-content: center;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
